import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';

/** Local wall-clock format used by the schedule contract: no offset/`Z`. */
export const ABSOLUTE_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

/** Formats an instant as the local wall-clock string for `timeZone`, matching the schedule contract. */
export function toAbsoluteDateString(date: Date, timeZone: string): string {
  return formatInTimeZone(date, timeZone, ABSOLUTE_DATE_FORMAT);
}

/** Parses a contract wall-clock string (interpreted in `timeZone`) back into an instant. */
export function fromAbsoluteDateString(value: string, timeZone: string): Date | undefined {
  const date = zonedTimeToUtc(value, timeZone);
  return Number.isNaN(date.getTime()) ? undefined : date;
}
